import React from "react";
import { Link as RouterLink, useParams } from "react-router-dom";
import { allLetters } from "../constants";

interface AlphabetNavigationProps {
  availableLetters: string[];
  currentLetter: string;
  category: string;
}

export const AlphabetNavigation: React.FC<AlphabetNavigationProps> = ({
  availableLetters,
  currentLetter,
  category,
}) => {
  return (
    <div className="bg-white border border-[#E5E7EB] py-4 px-6 mb-6 w-full lg:w-3/5">
      <div className="flex flex-wrap gap-2">
        {allLetters.map((letter) => {
          const isAvailable = availableLetters.includes(letter);
          const isActive = currentLetter === letter;

          if (!isAvailable) {
            return (
              <span
                key={letter}
                className="inline-flex items-center justify-center min-w-10 h-10 text-[15px] font-medium text-[#A0A7AD] cursor-not-allowed"
              >
                {letter}
              </span>
            );
          }

          return (
            <RouterLink
              key={letter}
              to={`/glossary/${category}/${letter.toLowerCase()}`}
              className={
                isActive
                  ? "inline-flex items-center justify-center min-w-10 h-10 text-[15px] font-medium bg-[#ED6E5C] text-white"
                  : "inline-flex items-center justify-center min-w-10 h-10 text-[15px] font-medium text-[#334155] hover:bg-gray-100"
              }
            >
              {letter}
            </RouterLink>
          );
        })}
      </div>
    </div>
  );
};
